import { useEffect, useState } from 'react';
import { useRect } from 'react-use-rect';
import type { SetElement } from 'react-use-rect/dist/use-rect';

const LAYOUT_BREAKPOINT = 544;

type LayoutConfig = {
  layout: 'column' | 'row';
  resultsPaddings: number[];
  sectionsSpacing: number;
  width?: number;
};

export function useLayoutConfig(
  isTransparentBack: boolean,
  [horizontalPadding, verticalPadding]: [number, number]
): [SetElement, LayoutConfig] {
  const [width, setWidth] = useState(0);
  const [ref] = useRect(
    ({ width }) => {
      setWidth(width);
    },
    { resize: true }
  );

  const [layoutConfig, setLayoutConfig] = useState<LayoutConfig>({
    layout: 'column',
    resultsPaddings: [40, 20],
    sectionsSpacing: 40,
    width: undefined
  });

  useEffect(() => {
    setLayoutConfig(() => {
      if (width < LAYOUT_BREAKPOINT) {
        return {
          layout: 'column',
          resultsPaddings: isTransparentBack
            ? [40, 20]
            : [40, horizontalPadding, verticalPadding],
          sectionsSpacing: 40,
          width
        };
      }

      if (width < 632) {
        return {
          layout: 'row',
          resultsPaddings: [24, 24],
          sectionsSpacing: 24,
          width
        };
      }

      if (width < 720) {
        return {
          layout: 'row',
          resultsPaddings: [32, 32],
          sectionsSpacing: 32,
          width
        };
      }

      return {
        layout: 'row',
        resultsPaddings: [40, 40],
        sectionsSpacing: 40,
        width
      };
    });
  }, [width, isTransparentBack, horizontalPadding, verticalPadding]);

  return [ref, layoutConfig];
}
